<pmt-action-modal [title]="'know-how.modalTitle' | transloco" submitButtonIconCode=""
    [submitButtonText]="'modal.sendButton' | transloco" (submitted)="onSubmit()" class="custom-modal-limiter"
    [isSaving]="isLoading">
    <ng-container *ngIf="trainerAdmins && trainerContacts">
        <div class="d-flex flex-column gap-2" [formGroup]="messageForm">
            <div>
                <label>{{'shared.emailing.from' | transloco}}</label>
                <div class="m-0">
                    <span class="badge bg-secondary" [tooltip]="sender?.email">
                        {{ sender?.givenName }} {{ sender?.familyName }}
                    </span>
                </div>
            </div>

            <div>
                <label>{{'shared.emailing.to' | transloco}}</label>
                <div class="m-0 d-flex flex-wrap gap-1">
                    <span *ngFor="let trainer of trainerContacts" class="badge bg-secondary" [tooltip]="trainer.email">
                        {{ trainer.firstName }} {{ trainer.lastName }}
                    </span>
                    <span *ngFor="let admin of trainerAdmins" class="badge bg-secondary" [tooltip]="admin.email">
                        {{ admin.firstName }} {{ admin.lastName }}
                    </span>
                </div>
            </div>

            <div>
                <label for="subject">{{'shared.emailing.subject' | transloco}}</label>
                <input id="subject" type="text" formControlName="subject" class="form-control" [disabled]="isLoading" />
            </div>

            <div>
                <label for="email">{{'shared.emailing.message' | transloco}}</label>
                <textarea id="email" formControlName="trainerMessage" rows="5" class="form-control"
                    [placeholder]="'shared.emailing.messagePlaceholder' | transloco"></textarea>
            </div>
        </div>
    </ng-container>
</pmt-action-modal>